module.exports = __webpack_public_path__ + "img/12.03f79016.jpg";